/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable import/no-duplicates */
import * as Apollo from "@apollo/client";

import * as Types from "./types";
import * as Operations from "./types";
const defaultOptions = {} as const;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetCurrentUserQuery, Types.GetCurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetCurrentUserQuery, Types.GetCurrentUserQueryVariables>(
    Operations.GetCurrentUser,
    options
  );
}
export function useGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCurrentUserQuery, Types.GetCurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetCurrentUserQuery, Types.GetCurrentUserQueryVariables>(
    Operations.GetCurrentUser,
    options
  );
}
export function useGetCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCurrentUserQuery, Types.GetCurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetCurrentUserQuery, Types.GetCurrentUserQueryVariables>(
    Operations.GetCurrentUser,
    options
  );
}
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<
  Types.GetCurrentUserQuery,
  Types.GetCurrentUserQueryVariables
>;
export type CreateHospitalConfigMutationFn = Apollo.MutationFunction<
  Types.CreateHospitalConfigMutation,
  Types.CreateHospitalConfigMutationVariables
>;

/**
 * __useCreateHospitalConfigMutation__
 *
 * To run a mutation, you first call `useCreateHospitalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHospitalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHospitalConfigMutation, { data, loading, error }] = useCreateHospitalConfigMutation({
 *   variables: {
 *      hospitalConfig: // value for 'hospitalConfig'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useCreateHospitalConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateHospitalConfigMutation,
    Types.CreateHospitalConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateHospitalConfigMutation, Types.CreateHospitalConfigMutationVariables>(
    Operations.CreateHospitalConfig,
    options
  );
}
export type CreateHospitalConfigMutationHookResult = ReturnType<typeof useCreateHospitalConfigMutation>;
export type CreateHospitalConfigMutationResult = Apollo.MutationResult<Types.CreateHospitalConfigMutation>;
export type CreateHospitalConfigMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateHospitalConfigMutation,
  Types.CreateHospitalConfigMutationVariables
>;

/**
 * __useGetHospitalConfigQuery__
 *
 * To run a query within a React component, call `useGetHospitalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHospitalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHospitalConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHospitalConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetHospitalConfigQuery, Types.GetHospitalConfigQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetHospitalConfigQuery, Types.GetHospitalConfigQueryVariables>(
    Operations.GetHospitalConfig,
    options
  );
}
export function useGetHospitalConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHospitalConfigQuery, Types.GetHospitalConfigQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetHospitalConfigQuery, Types.GetHospitalConfigQueryVariables>(
    Operations.GetHospitalConfig,
    options
  );
}
export function useGetHospitalConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHospitalConfigQuery, Types.GetHospitalConfigQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetHospitalConfigQuery, Types.GetHospitalConfigQueryVariables>(
    Operations.GetHospitalConfig,
    options
  );
}
export type GetHospitalConfigQueryHookResult = ReturnType<typeof useGetHospitalConfigQuery>;
export type GetHospitalConfigLazyQueryHookResult = ReturnType<typeof useGetHospitalConfigLazyQuery>;
export type GetHospitalConfigSuspenseQueryHookResult = ReturnType<typeof useGetHospitalConfigSuspenseQuery>;
export type GetHospitalConfigQueryResult = Apollo.QueryResult<
  Types.GetHospitalConfigQuery,
  Types.GetHospitalConfigQueryVariables
>;
export type UpdateHospitalConfigMutationFn = Apollo.MutationFunction<
  Types.UpdateHospitalConfigMutation,
  Types.UpdateHospitalConfigMutationVariables
>;

/**
 * __useUpdateHospitalConfigMutation__
 *
 * To run a mutation, you first call `useUpdateHospitalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHospitalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHospitalConfigMutation, { data, loading, error }] = useUpdateHospitalConfigMutation({
 *   variables: {
 *      hospitalConfig: // value for 'hospitalConfig'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUpdateHospitalConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateHospitalConfigMutation,
    Types.UpdateHospitalConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateHospitalConfigMutation, Types.UpdateHospitalConfigMutationVariables>(
    Operations.UpdateHospitalConfig,
    options
  );
}
export type UpdateHospitalConfigMutationHookResult = ReturnType<typeof useUpdateHospitalConfigMutation>;
export type UpdateHospitalConfigMutationResult = Apollo.MutationResult<Types.UpdateHospitalConfigMutation>;
export type UpdateHospitalConfigMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateHospitalConfigMutation,
  Types.UpdateHospitalConfigMutationVariables
>;
export type CreatePatientMutationFn = Apollo.MutationFunction<
  Types.CreatePatientMutation,
  Types.CreatePatientMutationVariables
>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      patient: // value for 'patient'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useCreatePatientMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.CreatePatientMutation, Types.CreatePatientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreatePatientMutation, Types.CreatePatientMutationVariables>(
    Operations.CreatePatient,
    options
  );
}
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationResult = Apollo.MutationResult<Types.CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePatientMutation,
  Types.CreatePatientMutationVariables
>;
export type CreatePatientPdfMutationFn = Apollo.MutationFunction<
  Types.CreatePatientPdfMutation,
  Types.CreatePatientPdfMutationVariables
>;

/**
 * __useCreatePatientPdfMutation__
 *
 * To run a mutation, you first call `useCreatePatientPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientPdfMutation, { data, loading, error }] = useCreatePatientPdfMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      results: // value for 'results'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useCreatePatientPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.CreatePatientPdfMutation, Types.CreatePatientPdfMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreatePatientPdfMutation, Types.CreatePatientPdfMutationVariables>(
    Operations.CreatePatientPdf,
    options
  );
}
export type CreatePatientPdfMutationHookResult = ReturnType<typeof useCreatePatientPdfMutation>;
export type CreatePatientPdfMutationResult = Apollo.MutationResult<Types.CreatePatientPdfMutation>;
export type CreatePatientPdfMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePatientPdfMutation,
  Types.CreatePatientPdfMutationVariables
>;
export type CreateResultMutationFn = Apollo.MutationFunction<
  Types.CreateResultMutation,
  Types.CreateResultMutationVariables
>;

/**
 * __useCreateResultMutation__
 *
 * To run a mutation, you first call `useCreateResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResultMutation, { data, loading, error }] = useCreateResultMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      result: // value for 'result'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useCreateResultMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.CreateResultMutation, Types.CreateResultMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateResultMutation, Types.CreateResultMutationVariables>(
    Operations.CreateResult,
    options
  );
}
export type CreateResultMutationHookResult = ReturnType<typeof useCreateResultMutation>;
export type CreateResultMutationResult = Apollo.MutationResult<Types.CreateResultMutation>;
export type CreateResultMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateResultMutation,
  Types.CreateResultMutationVariables
>;
export type DisEnrollPatientMutationFn = Apollo.MutationFunction<
  Types.DisEnrollPatientMutation,
  Types.DisEnrollPatientMutationVariables
>;

/**
 * __useDisEnrollPatientMutation__
 *
 * To run a mutation, you first call `useDisEnrollPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisEnrollPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disEnrollPatientMutation, { data, loading, error }] = useDisEnrollPatientMutation({
 *   variables: {
 *      withdrawalDate: // value for 'withdrawalDate'
 *      dryRun: // value for 'dryRun'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDisEnrollPatientMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.DisEnrollPatientMutation, Types.DisEnrollPatientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DisEnrollPatientMutation, Types.DisEnrollPatientMutationVariables>(
    Operations.DisEnrollPatient,
    options
  );
}
export type DisEnrollPatientMutationHookResult = ReturnType<typeof useDisEnrollPatientMutation>;
export type DisEnrollPatientMutationResult = Apollo.MutationResult<Types.DisEnrollPatientMutation>;
export type DisEnrollPatientMutationOptions = Apollo.BaseMutationOptions<
  Types.DisEnrollPatientMutation,
  Types.DisEnrollPatientMutationVariables
>;
export type EnrollPatientMutationFn = Apollo.MutationFunction<
  Types.EnrollPatientMutation,
  Types.EnrollPatientMutationVariables
>;

/**
 * __useEnrollPatientMutation__
 *
 * To run a mutation, you first call `useEnrollPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollPatientMutation, { data, loading, error }] = useEnrollPatientMutation({
 *   variables: {
 *      allocationDate: // value for 'allocationDate'
 *      dryRun: // value for 'dryRun'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useEnrollPatientMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.EnrollPatientMutation, Types.EnrollPatientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.EnrollPatientMutation, Types.EnrollPatientMutationVariables>(
    Operations.EnrollPatient,
    options
  );
}
export type EnrollPatientMutationHookResult = ReturnType<typeof useEnrollPatientMutation>;
export type EnrollPatientMutationResult = Apollo.MutationResult<Types.EnrollPatientMutation>;
export type EnrollPatientMutationOptions = Apollo.BaseMutationOptions<
  Types.EnrollPatientMutation,
  Types.EnrollPatientMutationVariables
>;

/**
 * __useGetPatientDetailsQuery__
 *
 * To run a query within a React component, call `useGetPatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetPatientDetailsQuery, Types.GetPatientDetailsQueryVariables> &
    ({ variables: Types.GetPatientDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPatientDetailsQuery, Types.GetPatientDetailsQueryVariables>(
    Operations.GetPatientDetails,
    options
  );
}
export function useGetPatientDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPatientDetailsQuery, Types.GetPatientDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPatientDetailsQuery, Types.GetPatientDetailsQueryVariables>(
    Operations.GetPatientDetails,
    options
  );
}
export function useGetPatientDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPatientDetailsQuery, Types.GetPatientDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPatientDetailsQuery, Types.GetPatientDetailsQueryVariables>(
    Operations.GetPatientDetails,
    options
  );
}
export type GetPatientDetailsQueryHookResult = ReturnType<typeof useGetPatientDetailsQuery>;
export type GetPatientDetailsLazyQueryHookResult = ReturnType<typeof useGetPatientDetailsLazyQuery>;
export type GetPatientDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPatientDetailsSuspenseQuery>;
export type GetPatientDetailsQueryResult = Apollo.QueryResult<
  Types.GetPatientDetailsQuery,
  Types.GetPatientDetailsQueryVariables
>;

/**
 * __useGetPatientResultsQuery__
 *
 * To run a query within a React component, call `useGetPatientResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientResultsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetPatientResultsQuery, Types.GetPatientResultsQueryVariables> &
    ({ variables: Types.GetPatientResultsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPatientResultsQuery, Types.GetPatientResultsQueryVariables>(
    Operations.GetPatientResults,
    options
  );
}
export function useGetPatientResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPatientResultsQuery, Types.GetPatientResultsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPatientResultsQuery, Types.GetPatientResultsQueryVariables>(
    Operations.GetPatientResults,
    options
  );
}
export function useGetPatientResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPatientResultsQuery, Types.GetPatientResultsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPatientResultsQuery, Types.GetPatientResultsQueryVariables>(
    Operations.GetPatientResults,
    options
  );
}
export type GetPatientResultsQueryHookResult = ReturnType<typeof useGetPatientResultsQuery>;
export type GetPatientResultsLazyQueryHookResult = ReturnType<typeof useGetPatientResultsLazyQuery>;
export type GetPatientResultsSuspenseQueryHookResult = ReturnType<typeof useGetPatientResultsSuspenseQuery>;
export type GetPatientResultsQueryResult = Apollo.QueryResult<
  Types.GetPatientResultsQuery,
  Types.GetPatientResultsQueryVariables
>;

/**
 * __useGetPatientsQuery__
 *
 * To run a query within a React component, call `useGetPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPatientsQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>(Operations.GetPatients, options);
}
export function useGetPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>(Operations.GetPatients, options);
}
export function useGetPatientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>(
    Operations.GetPatients,
    options
  );
}
export type GetPatientsQueryHookResult = ReturnType<typeof useGetPatientsQuery>;
export type GetPatientsLazyQueryHookResult = ReturnType<typeof useGetPatientsLazyQuery>;
export type GetPatientsSuspenseQueryHookResult = ReturnType<typeof useGetPatientsSuspenseQuery>;
export type GetPatientsQueryResult = Apollo.QueryResult<Types.GetPatientsQuery, Types.GetPatientsQueryVariables>;
export type UpdatePatientMutationFn = Apollo.MutationFunction<
  Types.UpdatePatientMutation,
  Types.UpdatePatientMutationVariables
>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      patient: // value for 'patient'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUpdatePatientMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpdatePatientMutation, Types.UpdatePatientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdatePatientMutation, Types.UpdatePatientMutationVariables>(
    Operations.UpdatePatient,
    options
  );
}
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<Types.UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdatePatientMutation,
  Types.UpdatePatientMutationVariables
>;
export type UpdateResultMutationFn = Apollo.MutationFunction<
  Types.UpdateResultMutation,
  Types.UpdateResultMutationVariables
>;

/**
 * __useUpdateResultMutation__
 *
 * To run a mutation, you first call `useUpdateResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResultMutation, { data, loading, error }] = useUpdateResultMutation({
 *   variables: {
 *      result: // value for 'result'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUpdateResultMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpdateResultMutation, Types.UpdateResultMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateResultMutation, Types.UpdateResultMutationVariables>(
    Operations.UpdateResult,
    options
  );
}
export type UpdateResultMutationHookResult = ReturnType<typeof useUpdateResultMutation>;
export type UpdateResultMutationResult = Apollo.MutationResult<Types.UpdateResultMutation>;
export type UpdateResultMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateResultMutation,
  Types.UpdateResultMutationVariables
>;

/**
 * __useGetPermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(
    Operations.GetPermissionGroups,
    options
  );
}
export function useGetPermissionGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(
    Operations.GetPermissionGroups,
    options
  );
}
export function useGetPermissionGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(
    Operations.GetPermissionGroups,
    options
  );
}
export type GetPermissionGroupsQueryHookResult = ReturnType<typeof useGetPermissionGroupsQuery>;
export type GetPermissionGroupsLazyQueryHookResult = ReturnType<typeof useGetPermissionGroupsLazyQuery>;
export type GetPermissionGroupsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionGroupsSuspenseQuery>;
export type GetPermissionGroupsQueryResult = Apollo.QueryResult<
  Types.GetPermissionGroupsQuery,
  Types.GetPermissionGroupsQueryVariables
>;

/**
 * __useGetRoleDetailsQuery__
 *
 * To run a query within a React component, call `useGetRoleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleDetailsQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetRoleDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetRoleDetailsQuery, Types.GetRoleDetailsQueryVariables> &
    ({ variables: Types.GetRoleDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetRoleDetailsQuery, Types.GetRoleDetailsQueryVariables>(
    Operations.GetRoleDetails,
    options
  );
}
export function useGetRoleDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRoleDetailsQuery, Types.GetRoleDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetRoleDetailsQuery, Types.GetRoleDetailsQueryVariables>(
    Operations.GetRoleDetails,
    options
  );
}
export function useGetRoleDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRoleDetailsQuery, Types.GetRoleDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetRoleDetailsQuery, Types.GetRoleDetailsQueryVariables>(
    Operations.GetRoleDetails,
    options
  );
}
export type GetRoleDetailsQueryHookResult = ReturnType<typeof useGetRoleDetailsQuery>;
export type GetRoleDetailsLazyQueryHookResult = ReturnType<typeof useGetRoleDetailsLazyQuery>;
export type GetRoleDetailsSuspenseQueryHookResult = ReturnType<typeof useGetRoleDetailsSuspenseQuery>;
export type GetRoleDetailsQueryResult = Apollo.QueryResult<
  Types.GetRoleDetailsQuery,
  Types.GetRoleDetailsQueryVariables
>;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetRolesQuery, Types.GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetRolesQuery, Types.GetRolesQueryVariables>(Operations.GetRoles, options);
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRolesQuery, Types.GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetRolesQuery, Types.GetRolesQueryVariables>(Operations.GetRoles, options);
}
export function useGetRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRolesQuery, Types.GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetRolesQuery, Types.GetRolesQueryVariables>(Operations.GetRoles, options);
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<Types.GetRolesQuery, Types.GetRolesQueryVariables>;
export type UpdateRoleMutationFn = Apollo.MutationFunction<Types.UpdateRoleMutation, Types.UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUpdateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpdateRoleMutation, Types.UpdateRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateRoleMutation, Types.UpdateRoleMutationVariables>(
    Operations.UpdateRole,
    options
  );
}
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<Types.UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateRoleMutation,
  Types.UpdateRoleMutationVariables
>;
export type CreateUserMutationFn = Apollo.MutationFunction<Types.CreateUserMutation, Types.CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.CreateUserMutation, Types.CreateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateUserMutation, Types.CreateUserMutationVariables>(
    Operations.CreateUser,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<Types.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateUserMutation,
  Types.CreateUserMutationVariables
>;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetUserDetailsQuery, Types.GetUserDetailsQueryVariables> &
    ({ variables: Types.GetUserDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetUserDetailsQuery, Types.GetUserDetailsQueryVariables>(
    Operations.GetUserDetails,
    options
  );
}
export function useGetUserDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserDetailsQuery, Types.GetUserDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetUserDetailsQuery, Types.GetUserDetailsQueryVariables>(
    Operations.GetUserDetails,
    options
  );
}
export function useGetUserDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserDetailsQuery, Types.GetUserDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetUserDetailsQuery, Types.GetUserDetailsQueryVariables>(
    Operations.GetUserDetails,
    options
  );
}
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUserDetailsSuspenseQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<
  Types.GetUserDetailsQuery,
  Types.GetUserDetailsQueryVariables
>;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(Operations.GetUsers, options);
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(Operations.GetUsers, options);
}
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(Operations.GetUsers, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<Types.GetUsersQuery, Types.GetUsersQueryVariables>;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(
    Operations.UpdateUser,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateUserMutation,
  Types.UpdateUserMutationVariables
>;
